/**
 * ProjectTreeSkeleton — shimmer placeholder rows shown while designs are
 * loading. Reuses the existing shimmer keyframe from app-shell.css.
 * Renders 3 shimmer rows that roughly match the l1/l2 tree structure.
 */
import React from 'react';

export default function ProjectTreeSkeleton() {
  return (
    <div className="tree-skeleton">
      <div className="skeleton-row">
        <div className="skeleton-avatar" />
        <div className="skeleton-label" style={{ width: '60%' }} />
      </div>
      <div className="skeleton-row">
        <div className="skeleton-avatar" />
        <div className="skeleton-label" style={{ width: '45%' }} />
      </div>
      <div className="skeleton-row">
        <div className="skeleton-avatar" />
        <div className="skeleton-label" style={{ width: '70%' }} />
      </div>
    </div>
  );
}
